<script>

import { mapState } from 'vuex'

export default {
  props: {
    indexData: Object
  },
  methods: {
    dismissDialog () {
      this.$emit('task')
    },
    showShareTips () {
      this.dismissDialog()
      this.$store.commit('shareTip', true)
    }
  },
  computed: {
    ...mapState(['finish_task_count'])
  },
  data () {
    return {
      taskPics: [require('@/assets/task_nomal.png'), require('@/assets/task_pass.png')],
      taskAward: [5, 5, 10, 15, 20],
      showClaim:false
    }
  }
}
</script>

<template>
  <div class="bg">
    <div class="balance">$ {{ indexData ? indexData.data.showBalance.toFixed(2) : '' }}</div>
    <div class="title"></div>
    <div class="reward">$0</div>
    <div class="reward-tips">$ 25 waiting to be claimed</div>
    <div class="task-tips">After opening the four treasure chests,<br>you can receive a reward of $70- $200</div>
    <div class="box-wrap">
      <div class="box-content">
        <div class="box"></div>
        <div class="box-base">
          <div v-if="!showClaim" class="box-reward">?</div>
          <div v-if="showClaim" class="claim">Claim</div>
        </div>
      </div>
      <div class="box-content">
        <div class="box"></div>
        <div class="box-base">
          <div v-if="!showClaim" class="box-reward">?</div>
          <div v-if="showClaim" class="claim">Claim</div>
        </div>
      </div>
      <div class="box-content">
        <div class="box"></div>
        <div class="box-base">
          <div v-if="!showClaim" class="box-reward">?</div>
          <div v-if="showClaim" class="claim">Claim</div>
        </div>
      </div>
      <div class="box-content">
        <div class="box"></div>
        <div class="box-base">
          <div v-if="!showClaim" class="box-reward">?</div>
          <div v-if="showClaim" class="claim">Claim</div>
        </div>
      </div>
    </div>

    <div class="time">End of this reward 23:00:00</div>


    <div class="share">
      <div class="whatsapp">Whatsapp</div>
      <div class="more"></div>
    </div>
  </div>
</template>

<style scoped>
.bg {
  width: 94.8rem;
  height: 55.6rem;
  align-self: start;
  background-image: url("@/assets/bg_task1.png");
  background-size: 100% 100%;
  margin-top: 6rem;
  position: relative;
}
.title {
  width: 68.7rem;
  height: 5.8rem;
  background-image: url("@/assets/title_task1.png");
  background-size: 100% 100%;
  position: relative;
  align-self: center;
  justify-self: center;
  margin-top: -1rem;
}
.balance {
  width: 17.6rem;
  height: 10.3rem;
  background-image: url("@/assets/mybalance1.png");
  background-size: 100% 100%;
  margin-left: -15rem;
  margin-top: 2rem;
  position: absolute;
  font-size: 3.4rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color:  #FFCA34 ;
  align-content: center;
  justify-content: center;
  text-align: center;
  padding-top: 3rem;
}
.share {
  width: 40rem;
  height: 8.6rem;
  display: flex;
  flex-direction: row;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -6rem;
}
.whatsapp {
  width: 28.4rem;
  height: 8.6rem;
  background-image: url("@/assets/bg_whatsapp.png");
  background-size: 100% 100%;
  align-self: center;
  justify-self: center;
  color: #FFF;
  font-size: 2.8rem;
  text-align: center;
  justify-content: center;
  align-content: center;
  font-weight: 600;
  line-height: normal;
  padding-left: 3rem;
}
.more {
  width: 8.9rem;
  height: 8.5rem;
  background-image: url("@/assets/bg_more.png");
  background-size: 100% 100%;
  align-self: center;
  justify-self: center;
}
.reward {
  text-align: center;
  font-size: 3.4rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background: linear-gradient(180deg, #FFFF0D 0%, #FFCA34 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top: 4.2rem;
}

.reward-tips {
  color: #FFF;
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
  text-shadow:
    1px 0 #A20E59,
    -1px 0 #A20E59,
    0 1px #A20E59,
    0 -1px #A20E59;
}

.task-tips {
  color: #FFCFF5;
  align-content: center;
  justify-content: center;
  font-size: 2rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  width: 49.2rem;
  height: 6.7rem;
  align-self: center;
  justify-self: center;
  background-image: url("@/assets/bg_tasktips1.png");
  background-size: 100% 100%;
  margin-top: 2rem;
  white-space: pre-wrap;
  text-align: center;
}
.box-wrap {
  width: 90%;
  height: auto;
  display: flex;
  flex-direction: row;
  margin-top: 3rem;
  align-self: center;
  justify-self: center;
}
.box-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
}
.box {
  width: 15.8rem;
  height: 11.1rem;
  background-image: url("@/assets/box_close_task1.png");
  background-size: 100% 100%;
  z-index: 1;
}
.box-base {
  width: 16.8rem;
  height: 15.9rem;
  margin-top: -4rem;
  background-image: url("@/assets/base_task1.png");
  background-size: 100% 100%;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-items: center;
  align-content: center;
  justify-content: center;
}
.box-reward {
  width: 7.1rem;
  height: 3.2rem;
  background-image: url("@/assets/bg_box_reward.png");
  background-size: 100% 100%;
  justify-content: center;
  align-content: center;
  text-align: center;
  margin-top: 3.5rem;
  color: #FFF;
  font-size: 2.4rem;
}
.claim {
  width: 11.6rem;
  height: 4.6rem;
  background-image: url("@/assets/bg_claim.png");
  background-size: 100% 100%;
  justify-content: center;
  align-content: center;
  text-align: center;
  margin-top: 3.5rem;
  color: #FFF;
  font-size: 2rem;
}
.time {
  width: auto;
  height: auto;
  color: #FFF;
  font-size: 2rem;
  font-weight: 600;
  line-height: normal;
  z-index: 2;
  position: absolute;
  align-self: center;
  justify-self: center;
  margin-top: 2rem;
}
</style>
